if (!customElements.get('video-modal')) {
  customElements.define(
    'video-modal',
    class VideoModal extends HTMLElement {
      constructor() {
        super();
        this.modalContent = this.querySelector('.video-modal__content');
        this.closeButton = this.querySelector('.video-modal__toggle');
        this.isOpen = false;

        this.onClose = this.hide.bind(this);
        this.onOverlayClick = (event) => {
          if (event.target === this || event.target.classList.contains('video-modal__content')) {
            this.hide();
          }
        };
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.onEscape = this.handleEscape.bind(this);
      }

      connectedCallback() {
        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.onClose);
        }
        this.addEventListener('click', this.onOverlayClick);
        if (!this.hasAttribute('moved')) {
          this.setAttribute('moved', 'true');
          document.body.appendChild(this);
        }
      }

      disconnectedCallback() {
        if (this.closeButton) {
          this.closeButton.removeEventListener('click', this.onClose);
        }
        this.removeEventListener('click', this.onOverlayClick);
        document.removeEventListener('keydown', this.onEscape);
      }

      show(opener) {
        this.openedBy = opener;
        this.setAttribute('open', '');
        this.isOpen = true;
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keydown', this.onEscape);

        const template = this.querySelector('template');
        if (template) {
          this.querySelector('.video-modal__content-info').appendChild(template.content.cloneNode(true));
          template.remove();
        }

        trapFocus(this, this.querySelector('.video-modal__content'));

        // Auto-play the video if available
        const video = this.querySelector('video');
        if (video) video.play();

        // For YouTube/Vimeo
        const iframe = this.querySelector('iframe');
        if (iframe) {
          const isYouTube = iframe.src.includes('youtube.com') || iframe.src.includes('youtu.be');
          const isVimeo = iframe.src.includes('vimeo.com');
          if (isYouTube) {
            iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          } else if (isVimeo) {
            iframe.contentWindow.postMessage('{"method":"play"}', '*');
          }
        }
      }

      hide() {
        this.removeAttribute('open');
        this.isOpen = false;
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keydown', this.onEscape);
        removeTrapFocus(this.openedBy);

        const video = this.querySelector('video');
        if (video) video.pause();

        const iframe = this.querySelector('iframe');
        if (iframe) {
          const isYouTube = iframe.src.includes('youtube.com') || iframe.src.includes('youtu.be');
          const isVimeo = iframe.src.includes('vimeo.com');
          if (isYouTube) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          } else if (isVimeo) {
            iframe.contentWindow.postMessage('{"method":"pause"}', '*');
          }
        }

        if (this.openedBy && typeof this.openedBy.focus === 'function') {
          this.openedBy.focus();
        }
      }

      handleBodyClick(event) {
        if (this.isOpen && !this.contains(event.target)) {
          this.hide();
        }
      }

      handleEscape(event) {
        if (event.key === 'Escape') this.hide();
      }
    }
  );
}
